import { render } from "./linkdinGeneral.vue?vue&type=template&id=218ed5a2"
import script from "./linkdinGeneral.vue?vue&type=script&lang=js"
export * from "./linkdinGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__